import script from "./FiftyPercent.vue?vue&type=script&setup=true&lang=js"
export * from "./FiftyPercent.vue?vue&type=script&setup=true&lang=js"

import "./FiftyPercent.vue?vue&type=style&index=0&id=477f7619&lang=scss"

const __exports__ = script;

export default __exports__